import React from 'react';
import http from '../../shared/http';

export const useFileUpload = endpoint => {
  const [uploadPercent, setUploadPercent] = React.useState(0.0);
  const [filename, setFilename] = React.useState(null);
  const [error, setError] = React.useState(null);
  const [status, setStatus] = React.useState('idle');
  const [filePayload, setFilePayload] = React.useState(null);

  const handleUploadProgress = progressEvent => {
    const percent = parseInt(
      (100.0 * progressEvent.loaded) / progressEvent.total,
      10
    );
    setUploadPercent(percent);
  };

  const uploadFile = file => {
    setFilename(file.name);
    setStatus('loading');
    http.uploadFile(endpoint, file, handleUploadProgress).then(
      res => {
        setStatus('success');
        setFilePayload(res.data);
      },
      error => {
        const response = error.response;
        let errorMessage;
        if (response && response.data.errors && response.data.errors.image) {
          errorMessage = response.data.errors.image.join(', ');
        } else {
          errorMessage = 'Something went wrong. Please try again.';
        }

        setStatus('error');
        setError(errorMessage);
      }
    );
  };

  return {
    status,
    filePayload,
    error,
    filename,
    uploadFile,
    uploadPercent
  };
};
